<template>
  <div class="check-container">
    <div class="title">搜索条件</div>
    <div class="check-search">
      <div class="div1">
        <span>商品名称</span>
        <input type="text" v-model="goodsName" />
      </div>
      <div class="div2">
        <span>批号</span>
        <input type="text" v-model="number" />
      </div>
      <div class="div3">
        <span>验证码</span>
        <input type="text"  v-model="code"/>
      </div>
      <div class="div4" @click="changeCode">

      <SIdentify   :identifyCode="identifyCode" ></SIdentify>

      </div>
      <div class="div5" @click="search">
        <img :src="require('@/assets/images/icon_search2.png')" alt="" />
        <span>搜索</span>
      </div>
    </div>
    
    <div class="title title2">药品检查列表</div>
    <el-table
      :cell-style="tableCellColor"
      :header-cell-style="tableHeaderColor"
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column
        prop="sn"
        align="left"
        style="padding-left: 14px"
        label="商品编号"
        width="100"
      >
      </el-table-column>
      <el-table-column prop="name" align="center" label="商品名称" width="220">
      </el-table-column>
      <el-table-column prop="specification" align="center" label="商品规格" width="120">
      </el-table-column>
      <el-table-column prop="manufacturer" align="center" label="商品产地" width="120">
      </el-table-column>
      <el-table-column prop="approval" align="center" label="批准文号" width="120">
      </el-table-column>
      <el-table-column prop="pihao" align="center" label="批号" width="120">
      </el-table-column>
      <el-table-column
        prop="id"
        align="center"
        label="图片来源ID"
        width="100"
      >
      <template slot-scope="scope"> 
          <!-- <div class="event-btn"  @click="upload(scope.row.id)"> -->
          <div class="event-btn"  >
            <a :href="default_URL+`/fronted/goods/report_file/download/${scope.row.id}?x-jy-token=${$store.state.token}`"><span>下载</span></a>
            <!-- <a ><span>下载</span></a> -->

          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="event" label="操作" align="center" width="210">
        <template v-slot="{ row }">
          <div class="event-btn">
            <span class="span1" @click="goto">售后详情</span>
            <span v-if="row.event == 0" class="span2">取消售后</span>
            <span v-if="row.event == 1" class="span3">已取消</span>
            <span v-if="row.event == 2" class="span3">已关闭</span>
          </div>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页 -->
  <el-pagination
        class="pagination"
        background 
        layout="prev, pager, next"
        :page-size="pageSize"
        @current-change="changepage"
        :total="total"
        :current-page="pageNumber"
        v-if="tableData.length"
        >
          </el-pagination>
  <error v-if="errorShow">{{message}}</error>
  </div>
</template>
  <script>
  import axios from 'axios'
  import SIdentify from '../../../../components/identify'
  import config from '../../../../utils/config'
import Error from '../../../../components/error.vue';
export default {
  components: {
    SIdentify: SIdentify,
    Error
  },
  data() {
    return {
      goodsName:'',
      number:'',
      code:'',
      tableData: [],
      identifyCode:'',
      identifyCodes:'1234567890',
      pageSize:10,
      pageNumber:1,
      total:'',
      message:'',
      errorShow:false,

    };
  },
  created(){

  },
  mounted(){
     this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
    //console.log( this.identifyCode);
  },
  methods: {
    // goto() {
    //   this.$router.push({ path: "/person/servicedetail" });
    // },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return (
          "background-color: #fafafa;color:#808080;font-weight:400;font-size:14px;" +
          (columnIndex == 0 ? "padding-left:14px" : "")
        );
      }
    },
    tableCellColor({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "padding-left:14px;";
      }
    },
    changepage(val){
      this.pageNumber = val
      this.search()
    },
    search(){
      if(this.code = "" || this.code !== this.identifyCode){
        this.code = ""
        this.message = "验证码错误"
        this.errorShow = true
        return
      }else{
         this.code = this.identifyCode
         this.$api.GET_BATCH({
                 goodsName:this.goodsName,
                 number:this.number,
                 pageSize:this.pageSize,
                 pageNumber:this.pageNumber
               }).then(res=>{
                 //console.log(res);
                 if(res.status){
                   this.tableData = res.data
                   this.total = res.totals
                 }else{
                       this.message = '查询报告失败'
                        this.errorShow = true

                  }
           })
      }
    },
    error(){
       this.errorShow = false
    },
    //下载图片
    upload(id){
      //console.log(id);
          
      //  axios({
      //    method:'get',
      //    url:'http://test.api.dgsjyyy.com/fronted/goods/batch/download?id='+id,
	    //    responseType:[ "image/png", "image/jpeg"] ,
      //  }).then(res=>{
      //       console.log(res);
      //  })
      // this.$api.GET_BATCHUPLOAD({id}).then(res=>{
      //   console.log(res);
      // })
    
    },
    // 点击验证码刷新验证码
    changeCode () {
      this.identifyCode = ''
      this.makeCode(this.identifyCodes, 4)
    },
    // 生成一个随机整数  randomNum(0, 10) 0 到 10 的随机整数， 包含 0 和 10
    randomNum (min, max) {
      max = max + 1
      return Math.floor(Math.random() * (max - min) + min)
    },
    // 随机生成验证码字符串
    makeCode (data, len) {
      for (let i = 0; i < len; i++) {
        this.identifyCode += data[this.randomNum(0, data.length - 1)]
      }
    }

  },
};
</script>

  <style lang="scss" scoped>
.check-container {
  position: relative;
  background: #ffffff;
  padding: 38px 32px 40px 46px;
  min-height: 1000px;
  > .title {
    font-size: 22px;
    color: #333333;
    font-weight: 600;
    margin-bottom: 24px;
  }
  .check-search {
    display: flex;
    font-size: 14px;
    color: #3f3f4d;
    padding-bottom: 30px;
    border-bottom: 1px solid #f5f5f5;
    input {
      border: 1px solid #f5f5f5;
      height: 40px;
      border-radius: 3px;
      padding:0 18px;
    }
    .div1 {
      input {
        width: 228px;
        margin: 0 20px 0 14px;
      }
    }
    .div2 {
      input {
        width: 170px;
        margin: 0 18px 0 14px;
      }
    }
    .div3 {
      input {
        width: 80px;
        margin: 0 14px 0 16px;
      }
    }
    .div4 {
      width: 78px;
      border: 1px solid #f5f5f5;
      margin-right: 16px;
    }
    .div5 {
      width: 94px;
      text-align: center;
      height: 40px;
      line-height: 40px;
      color: #ffffff;
      background: #fa4b4b;
      cursor: pointer;
      border-radius: 4px;
      img{
        vertical-align: middle;
        padding-bottom: 3px;
      }
    }
  }
  .title2 {
    margin: 30px 0;
  }
  /deep/ .el-table {
    color: #505050;
    font-size: 14px;
  //  min-height: 940px;
    td {
      height: 78px;
    }
  }
  .event-btn{
    span{
      cursor: pointer;
      border-radius: 2px;
      display: inline-block;
      width: 68px;
      height: 28px;
      border: 1px solid #e0e0e0;
      line-height: 28px;
      text-align: center;
      &::before{
        content:'';
        display: inline-block;
        margin-right: 2px;
        position: relative;
        top: 1px;
        width: 13px;
        height: 14px;
        background: url('../../../../assets/images/icon_download.png') no-repeat;
      
      }
    }

  }
}
.coderight{
  width: 78px;
  height: 40px;
}
.pagination{
  text-align: center;
  margin-top: 40px;
  color: #fa4b4b;
}
</style>


// WEBPACK FOOTER //
// src/pages/person/components/person-check/index.vue